import { render, staticRenderFns } from "./RelatorioTempoVisualizacaoProduto.vue?vue&type=template&id=0a4819fe"
import script from "./RelatorioTempoVisualizacaoProduto.vue?vue&type=script&lang=js"
export * from "./RelatorioTempoVisualizacaoProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports